import React, { FC, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { toastLayer } from '@utils'
import { doProductMobx, menuMobx, productSaleMobx } from 'restaurant'
import { Stepper, Icon, SoldoutFoldBar } from '@cps'
import { classNames, format } from '@dt/fe-utils'
import { decorationMobx } from '@mobxStore'
import './index.scss'
import { filter, find, sortBy } from '@dt/fe-utils/dist/lodash'

interface IProps {
  group: IDoModifierGroup;
  subsColor?: string; // 不能打包
  hideModifyDiscount?: boolean;
}

const MultiModify: FC<IProps> = ({ group, subsColor, hideModifyDiscount }) => {
  // 显示更多加料项，默认超过3个收缩
  const [hasMore, setHasMore] = useState<boolean>(false)
  const [modifiers, setModifiers] = useState<IDoModifierGroupItem[]>([])
  const [choosedName, setChoosedName] = useState<string>('')
  const soldoutKey = `${doProductMobx.doProduct.no}_${group.no}`
  const checked = !!group.modifiers.find(item => item.cnt > 0)
  const showSoldout = menuMobx.openFoldSoldoutScale === 1 && !!find(group.modifiers, modify => productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0)
  // 加减加料数量
  const handleChangeCnt = (event, modify, isAdd: boolean) => {
    event.stopPropagation()
    if (isAdd) {
      const result = doProductMobx.addModifier(group.no, modify.no)
      if (result === 'MODIFIER') {
        toastLayer.info(i18n.t('modifier.maxSelect', { name: modify.name, cnt: modify.maxCnt }))
      } else if (result === 'MODIFIERGROUP_CNT') {
        toastLayer.info(i18n.t('modifier.maxSelect', { name: group.name, cnt: group.maxCnt }))
      } else if (result === 'MODIFIERGROUP_ITEM') {
        toastLayer.info(i18n.t('modifier.maxSelect', { name: group.name, cnt: group.selectMax }))
      }
    } else {
      doProductMobx.reduceModifier(group.no, modify.no)
    }
  }
  // 重置加料项
  const handleReset = () => {
    doProductMobx.clearModifierGroup(group.no)
  }
  // 重置加料项
  const handlehasMore = (event) => {
    event.stopPropagation()
    setHasMore(true)
  }

  const getChooseName = () => {
    let choosedName = ''
    if (group.selectMax === 1) {
      if (group.selectMin === 0) {
        choosedName = i18n.t('productdetail.optional', { count: group.selectMax })
      } else {
        choosedName = i18n.t('modifier.mustSelect')
      }
    } else if (group.selectMin > 0) {
      if (group.cnt === 0) {
        choosedName = i18n.t('modifier.selectMulit', { min: group.selectMin, max: group.selectMax })
      }
    } else {
      choosedName = i18n.t('productdetail.optional', { count: group.selectMax })
    }
    setChoosedName(choosedName)
  }

  useEffect(() => {
    getChooseName()
    setHasMore(!showSoldout ? group.modifiers.length <= 4 : true)
    const modifiers = !showSoldout || menuMobx.foldSoldoutMap?.[soldoutKey] === true
      ? sortBy(group.modifiers || [], (modify) => productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0 ? 1 : 0)
      : filter(group.modifiers, modify => !(productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0))
    setModifiers([...modifiers])
  }, [group, menuMobx.foldSoldoutMap?.[soldoutKey], showSoldout])

  return (
    <div key={group.no} className='multi-modify-item'>
      <div className='title space-between'>
        <span>{group.name}</span>
        <button className={classNames('reset-btn', { disabled: !checked })} disabled={!checked} data-cypid={`moltiModifyReset_no_${group?.no}`} onClick={handleReset}>{i18n.t('modifier.reset')}</button>
        <span className={`${!group.isReady && subsColor}`}>{choosedName}</span>
      </div>
      <div className='content'>
        {
          (hasMore ? modifiers : modifiers.filter((v, i) => i <= 3)).map((modify, index) => {
            const saleCnt = productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]
            const stopSale = saleCnt && saleCnt.cnt === 0
            const price = modify.price
            const actualPrice = !hideModifyDiscount && modify.discountPrice && modify.discountPrice > 0 ? modify.actualPrice : modify.price
            return (
              <div
                className={`item ${modify.cnt > 0 ? 'selected' : ''} ${stopSale ? 'disabled' : ''}`}
                key={modify.no}
                data-cypid={`moltiModifyChange_no_${modify.no}`}
                onClick={(event) => {
                  !stopSale && !modify.cnt && handleChangeCnt(event, modify, true)
                }}
              >
                <div className='price-wrap'>
                  <h6 className={`${!price ? 'no-price' : ''}`}>{modify.name}</h6>
                  {!stopSale && price ? <span className='price'>{format.toPrice(actualPrice)} {actualPrice !== price && <del> {format.toPrice(price)}</del>}</span> : null}
                  {decorationMobx.mealDecorates.showSalesCnt && !stopSale && saleCnt?.cnt > 0 ? <span className='sub-price-limit'>{`(${i18n.t('cart.limit')}: ${saleCnt.cnt})`}</span> : null}
                  {stopSale ? <span className='sub-price-limit'>{i18n.t('common.soldout')}</span> : null}
                </div>
                {modify.cnt > 0 && <Stepper cnt={modify.cnt} onChange={(isAdd, event) => !stopSale && handleChangeCnt(event, modify, isAdd)} min={0} max={modify.maxCnt} theme='primary' size='small' disabled={stopSale} />}
                {(!hasMore && index === 3 && !showSoldout) && (
                  <div className='more-btn-wrapper'>
                    <div className='more-btn-wrap' data-cypid={`moltiModifyShowMore_no_${group.no}`} onClick={handlehasMore}>
                      <span>{i18n.t('modifier.moreList')}</span>
                      <Icon name='jiantou' />
                    </div>
                  </div>
                )}
              </div>
            )
          })
        }
        {!!showSoldout && (
          <SoldoutFoldBar
            className='item'
            show={menuMobx.foldSoldoutMap?.[soldoutKey] === true}
            no={soldoutKey}
            from='modify'
          />
        )}
      </div>
    </div>
  )
}

export default observer(MultiModify)
